<template>
    <div class="desing">
        <titles name="合同信息"></titles>
        <ul class="content">
            <li>
                <div class="titleDiv">
                    合同号： 
                    <span class="titleSpan">{{item.contractNumber}}</span>
                </div>
                <div class="titleDiv">
                    合同签订日期： 
                    <span class="titleSpan">{{item.signingTime}}</span> 
                </div>
                <div class="titleDiv">
                    合同金额：
                    <span class="titleSpan">￥{{item.contractMoney}}</span> 
                </div>
                <div class="flex-row titleDiv">
                    <p class="m-r-51">合同附件</p>
                    <div class="titleSpan">
                        <img class="m-r-20" :src="lion" alt="">
                        <img :src="lion" alt="">
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import titles from '@/components/titiles.vue';
import lion from '@/assets/img/lion.jpg'
export default {
    components:{
        titles,
    },
    props: {
        item: {
        type: Object,
        default: {}
        },
    },
    data(){
        return {
            lion
        }
    }
}
</script>
<style lang="scss" scoped>
.desing{
    background: $ffff;
    padding-bottom: 100px;
    margin-bottom: 20px;
    .content{
        margin:20px 55px 0 55px;
        background: $ffff;
        font-size:24px;
        color:$color-51;
        li{
            div{
                margin-bottom: 27px;
            }
            img{
                width:110px;
                height:110px;
            }
        }
        span{
            color: $color-153;
        }
    }
}
.titleDiv{
    position: relative;
    .titleSpan{
        position: absolute;
        left: 160px;
    }
}
</style>


